module.exports = __webpack_public_path__ + "img/yiyao_lunzhuang_suoluetu.48c8f315.png";